export default __webpack_public_path__ + "static/media/crs_logo.c6fd1be0.png";